import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    ExportExcelRight
} from '../../../business-components/Excel/Excel'

import {
    formataListExcel
} from '../../../business-components/Excel/ExcelService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosTextoQuebraEspecial,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'

import {
    tituloCliente,
} from '../cliente-form/ClienteService'

import DespesaAnualChart from '../estudo-chart/DespesaAnualChart'



const EstudoFormDespesasDespesaMensalDetalhada = ( { values, estudo, vars, report, indInicial, indFinal, popup, popupGrafico } ) => {

    const DespesasDespesaMensalDetalhada = () => {

        let headList = [
            {
                colSpan: 12,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoDespesaMensal, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tipoPeriodicidadePagto, report, null, null, null, true),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMensalAtualQuebraEspecial, report),
            },
           
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorTotal, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.mesAnoInicialIdadeQuebraEspecial, report,
                    null, null, null, true),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.mesAnoFinalIdadeQuebraEspecial, report,
                    null, null, null, true),
            },
        ]

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                    //popup={popup}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.despesaMensalDetalhada?.map((item, ind) => {
                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[0].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[1].colSpan}
                                >
                                    {item.valor}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[2].colSpan}
                                >
                                    {item.descricaoTipoPeriodicidadePagto}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[3].colSpan}
                                >
                                    {item.valorMensal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[4].colSpan}
                                >
                                    {item.percMensal}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[5].colSpan}
                                >
                                    {item.valorTotal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[6].colSpan}
                                >
                                    {item.mesAnoInicial}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[7].colSpan}
                                >
                                    {item.mesAnoFinal}
                                </TableCellBodyExibeDados>
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>  
        )
    }

    return (
        report
            ?
                <GridContainer
                    className={indInicial === 0 ? 'mt--8' : ''}
                >
                    <GridItem12>
                        <DespesasDespesaMensalDetalhada/>
                    </GridItem12>
                </GridContainer>
            :
                <>
                    <ExportExcelRight
                        listExcel={formataListExcel(estudo.current.despesaMensalDetalhada,
                            ['descricao', 'valor', 'descricaoTipoPeriodicidadePagto', 'valorMensal',
                                'valorTotal', 'mesAnoInicial', 'mesAnoFinal'])
                        }
                        nomeArquivoExcel={LABEL.despesaMensal + ' ' + tituloCliente(values)}
                    />

                    <CardGridEstudoPadrao
                        label={LABEL.despesaMensal}
                        component={<DespesasDespesaMensalDetalhada/>}
                        overflowX={true}
                        popup={popup}
                        grafico={
                            popupGrafico
                                ? 
                                    <DespesaAnualChart
                                        values={values}
                                        estudo={estudo}
                                        vars={vars}
                                        popup={true}
                                    />
                                :
                                    ''
                        }
                        graficoTitle={popupGrafico ? LABEL.despesaAnualLongoTempo : ''}
                    />
                </>
    )
}

export default EstudoFormDespesasDespesaMensalDetalhada